import {AccreditationBody, FeeType, StandardName} from "../store/state/order.state";

export interface ConfigurationWithClientCountry extends Configuration {
	clientCountryConfig: ClientCountryBasedConfig | null;
}

export interface Configuration {
	dekraMotherPage: string;
	compromisedPasswordsFile?: string;

	footer: {
		items: {
			label: string,
			link: string,
			isRelativeUrl?: boolean
			openInSameTab?: boolean
		}[]
	},

	dateFormat: string;
	dateTimeFormat: string;
	timeFormat: string;

	cookieBanner: {
		items: CookiesBannerLink[]
	},

	cookieSettings: CookiesConfig;
	setCookiesOnStartup: boolean;
}

export interface ClientCountryBasedConfig {
	accreditationBody: AccreditationBody,
	multisiteContactFormAvailable: boolean,
	assigneeFilterForCountry: string[],
	order: {
		pricing: {
			format: string;
			integersWithoutDecimalPart: boolean;
			showDailyRate: boolean;
			currency: {
				symbol: string,
				format: string
			},
			show3YearsTotalForClient: boolean;
		},

		showBillingInfo: boolean;
		showScheduleCallBanner: boolean;
		showIso9001CatastrophicRisk: boolean;
		showPartTimeEmployees: boolean;
		iso27xScopeFixed: boolean;
		additionalParamsIncluded: { [key: string]: boolean };
		additionalParamsPatterns: { [key: string]: string }
		zipCodeCorrector?: (value: string) => string
	},

	pricingAdjustments: {
		fees: FeeConfig[]
	}
}

export interface FeeConfig {
	type: FeeType,
	excludeForProducts: StandardName[],
	minAmount: number,
	maxAmount: number,
	label: string,
	placeholder: string,
	mode: FeeMode
	applicationPolicy: ApplicationPolicy,
	excludeForTransfer?: boolean
}

export enum FeeMode {
	PER_YEAR = 'PER_YEAR',
	PER_EVENT = 'PER_EVENT',
}

export enum ApplicationPolicy {
	EVERY_YEAR = 'EVERY_YEAR',
	EVERY_AUDIT_EVENT = 'EVERY_AUDIT_EVENT',
	EVERY_AUDIT_CYCLE = 'EVERY_AUDIT_CYCLE'
}

export interface CookiesBannerLink {
	id?: string
	label: string,
	link: string,
	isRelativeUrl?: boolean
	openInSameTab?: boolean
}

export interface CookiesConfig {
	marketing: CookieSettings[];
	mandatory: CookieSettings[];
	comfort: CookieSettings[];
	statistics: CookieSettings[];
}

export interface CookieSettings {
	id: string;
	name: string;
	isRequired?: boolean;
	details: CookieSettingsDetails[];
}

export interface CookieSettingsDetails {
	key: string;
	value: string | string[];
	isUrl?: boolean;
}
